import styled from 'styled-components';

import { createSingleInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';
import { basicBodyTextStyle, basicSmallTextStyle, fonts, StyledFlex } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';

import { DeviceCellDates } from './DeviceCellDates';

type DeviceCellProps = {
   readonly medicalDeviceCode: string;
   readonly medicalDeviceName: string;
   readonly itemsCount?: number;
   readonly itemsPerMonthCount?: number;
   readonly firstSupplyDate?: string;
   readonly supplyMonthsCount?: number;
};

const StyledDeviceCell = styled(StyledFlex)`
   width: 100%;
   overflow: hidden;
`;
StyledDeviceCell.displayName = 'StyledFlex';

const StyledOrderDetails = styled.span`
   ${basicSmallTextStyle}
`;
StyledOrderDetails.displayName = 'StyledDeviceCell';

const StyledDeviceCodeAndName = styled.span`
   ${basicBodyTextStyle}

   font-weight: ${fonts.fontWeightBold};
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
`;

export const DeviceCell = (props: DeviceCellProps): JSX.Element => {
   const translate = useTranslate();
   const shouldDisplayDatesElement = props.firstSupplyDate && props.supplyMonthsCount;

   return (
      <StyledDeviceCell direction={'column'} gap={'4px'}>
         <StyledDeviceCodeAndName>
            {props.medicalDeviceCode} {props.medicalDeviceName}
         </StyledDeviceCodeAndName>
         <StyledOrderDetails>
            {props.itemsCount
               ? translate(
                    createSingleInterpolatedTranslationKey(
                       medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.units,
                       'count',
                       props.itemsCount
                    )
                 )
               : null}
            {props.itemsPerMonthCount
               ? translate(
                    createSingleInterpolatedTranslationKey(
                       medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.unitsPerMonth,
                       'count',
                       props.itemsPerMonthCount
                    )
                 )
               : null}
            {shouldDisplayDatesElement && props.itemsPerMonthCount ? ', ' : null}
            {shouldDisplayDatesElement ? (
               <DeviceCellDates firstSupplyDate={props.firstSupplyDate} supplyMonthsCount={props.supplyMonthsCount} />
            ) : null}
         </StyledOrderDetails>
      </StyledDeviceCell>
   );
};
